/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Public_Doc_Estimated_Reading_TimeInputs */

const en_public_doc_estimated_reading_time = /** @type {(inputs: Public_Doc_Estimated_Reading_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.minutes} min read`)
};

const es_public_doc_estimated_reading_time = /** @type {(inputs: Public_Doc_Estimated_Reading_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aproximadamente ${i?.minutes} min de lectura`)
};

/**
* | output |
* | --- |
* | "About {minutes} min read" |
*
* @param {Public_Doc_Estimated_Reading_TimeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const public_doc_estimated_reading_time = /** @type {((inputs: Public_Doc_Estimated_Reading_TimeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Doc_Estimated_Reading_TimeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_public_doc_estimated_reading_time(inputs)
	return en_public_doc_estimated_reading_time(inputs)
});